import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { TagItem } from '../../tagsManagerGrid/types';

export class TagsNetworkFilterBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(companyIds: Array<string>): Promise<Array<TagItem>> {
    throw new Error('Not implemented');
  }
}
